import { Key } from 'react';
import { Fade, FadeProps } from 'react-awesome-reveal';
import styled from 'styled-components';

export const CascadingText = (props: FadeProps & { key?: Key }) => {
  return (
    <FadeWrapper delay={0} cascade damping={5e-2} {...props} key={props.key}>
      {props.children}
    </FadeWrapper>
  );
};

const FadeWrapper = styled(Fade)`
  white-space: normal !important;
  width: unset !important;
`;
